{
  "title": "Help",
  "howItWorks": "How it works",
  "more": "What is this?",
  "readMore": "Read more"
}
